<template>
  <div class="reuseHeader">
    <div class="arrow" @click="back">
      <van-icon name="arrow-left"  class="icon-left"/>
       <div class="center">{{title}}</div>
    </div>
    <div class="detailsRight" v-if="isDetails">
      <img @click="show = true" src="@/assets/customer-service.png" alt="">
    </div>
    <div class="right" v-else></div>
    <van-action-sheet
      v-model="show"
      style="overflow-y: visible"
      @close="closePop">
      <template>
        <div class="feedBack">
          <div class="feedHeader">
            <h5>Feedback</h5>
          </div>
          <div class="feedMain">
            <p class="subTip">Describe the problem encountered：</p>
              <van-field
                v-model="feedBackText"
                rows="3"
                autosize
                type="textarea"
                maxlength="200"
                placeholder="Please enter"
                show-word-limit
              >
              <!-- <template  #left-icon>
                <img src="@/assets/orders.png" alt="" class="placeholder-icon" >
              </template> -->
            </van-field>
            <van-button color="#F4EC00" round :loading="btnLoading" loading-type="spinner" @click="submit" :disabled="!feedBackText" class="reuseBtn">Submit</van-button>
            <p class="phoneTip">
              You can also call customer service directly：
            </p>
            <div class="copyPhone">
              <div class="left">{{customerPhone}}</div>
              <div class="btn" @click="copyPhone">Copy</div>
            </div>
          </div>
          <div class="close" @click="closePop">
            <img src="@/assets/closePopIcon.png" alt="">
          </div>
        </div>
      </template>
    </van-action-sheet>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { feedBack, getCustomerInfo } from '@/http/api'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isDetails: {
      type: Boolean,
      default: true
    },
    toBack: {
      type: Function
    },
    backDot: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      feedBackText: '',
      btnLoading: false,
      customerPhone: ''
    }
  },
  created () {
    if (this.isDetails) {
      this.getPhone()
    }
  },
  methods: {
    back () {
      if (this.backDot) {
        this.$emit('backDot')
      }
      if (this.toBack) {
        this.$emit('toBack')
        return
      }
      if (this.$route.path !== sessionStorage.getItem('initialPath')) {
        this.$router.go(-1)
        return
      }
      this.backToNative()
    },
    backToNative () {
      const steps = window.history.length - 1
      if (steps <= 0) {
        this.callNativeBack()
        return
      }
      let finished = false
      const finish = () => {
        if (finished) return
        finished = true
        window.removeEventListener('popstate', onPopState, true)
        const remaining = window.history.length - 1
        if (remaining > 0) {
          window.history.go(-remaining)
          setTimeout(() => this.callNativeBack(), 100)
          return
        }
        this.callNativeBack()
      }
      const onPopState = () => finish()
      window.addEventListener('popstate', onPopState, true)
      window.history.go(-steps)
      setTimeout(finish, 150)
    },
    callNativeBack () {
      try {
        this.$javaNative(0)
      } catch (e) {}
    },
    closePop () {
      this.show = false
      this.feedBackText = ''
    },
    submit () {
      this.btnLoading = true
      feedBack({
        content: this.feedBackText,
        title: localStorage.getItem('pageTitle')
      }).then(res => {
        if (res.code === '200') {
          this.$toast('Sent successfully')
          this.feedBackText = ''
          this.show = false
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    copyPhone () {
      this.$copyText(this.customerPhone).then(() => {
        Toast('Copy successfully')
      })
    },
    getPhone () {
      getCustomerInfo().then(res => {
        if (res.code === '200') {
          this.customerPhone = res.data.phone
        }
      })
    }

  }
}
</script>

<style scoped lang="less">
.reuseHeader {
  position: sticky;
  top: 0;
  // margin: 0 -16px;
  z-index: 10;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;

  .arrow{
    display: flex;
    // justify-content: center;
    align-items: center;
    cursor: pointer;
    .icon-left{
       width: 24px;
      font-weight: 800;
      font-size: 24px;
      color: #000;
      margin-right: 12px;
    }
      .center {
    font-size: 18px;
    font-weight: bold;
  }
  }

  .detailsRight {
    display: flex;
    align-items: center;
    img {
      height: 30px;
    }
    span {
      color: #AE24F3;
      font-size: 14px;
    }
  }
  .right {
    width: 30px;
  }
}
.feedBack {
  // width: ;
  padding: 20px 32px;
  .feedHeader {
    display: flex;
    justify-content: center;
    // padding-bottom: 16px;
    // border-bottom: 1px solid #ececec;
    h5 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
  }
  .feedMain {

    background-color: #fff;
    border-radius: 16px;
    padding: 24px 0px 0 0;
    .subTip {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      text-align: left;
    }
    .van-field {
      background: #F5F5F3;
      height: 162px;
      border-radius: 20px;
      margin: 12px 0;
    }

    .reuseBtn {
      color: #333333 !important;
      font-size: 16px;
      font-family: Poppins, Poppins;
      font-weight: 600;
      width: 311px;
    }
    .reuseBtn:disabled{
      background: #dedcda !important;
      border: none !important;
    }
    .phoneTip {
      font-family: PingFang SC, PingFang SC;
      font-size: 12px;
      font-weight: 500;
      color: #000000;
      font-style: normal;
      text-align: left;
      margin: 16px 0 ;
    }
    .copyPhone {
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 52px;
      .left{
        flex: 1;
        height: 52px;
        border: 1px solid #888888;
        background: #FFFFFF;
        border-radius: 50px;
        font-weight: 500;
      }
      .btn {
        width: 95px;
        height: 52px;
        font-family: Roboto, Roboto;
        background: #FF9225;
        border-radius: 50px;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 500;
        margin-left: 8px;
      }
    }
  }
  .close {
    position: absolute;
    top: 22px;
    right: 22px;
    transform: translateX(50%);
    width: 24px;
    height: 24px;
    pointer-events: auto;
    display: flex;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
// .van-popup {
//   border-radius: 10px;
// }
/deep/ .van-field__control {
  min-height: 125px !important;
}
/deep/ .van-cell{
  padding: 9px 7px !important;
}
.placeholder-icon{
  margin-top: 3px;
  height: 18px;
  width: 18px;
}
</style>
